/**
 * Pluralize a word
 *
 * @param count - The count of the noun
 * @param noun - The noun to pluralize
 * @param suffix - The suffix to add to the noun
 *
 * @returns The pluralized word
 */
export function pluralize(noun: string, count: number, suffix: string = 's'): string {
  return `${noun}${count !== 1 ? suffix : ''}`;
}
